import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Storage } from '@ionic/storage'

import {AuthService} from "../../services/auth.service";
import {SplashPage} from "../splash/splash";

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

  user: any = {};
  private data;
  private warning:string = '';
  private showWarning: boolean = false;

  constructor(public authService: AuthService,
              public storage: Storage,
              public navCtrl: NavController) {}

  ngOnInit() {}

  signIn(){
    this.storage.ready().then(()=>{
      this.authService.connect(this.user).subscribe(
        data => {
          if(data.success){
            this.data = data.result;
            this.authService.setAuthData(this.user, this.data.user, this.data.token);
            this.navCtrl.setRoot(SplashPage);
          }else{
            this.warning = data.error.errorString;
            this.showWarning = true;
          }

        }
      );
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts